module.exports = __webpack_public_path__ + "img/40d7a38.png";